import { BasicModalContext } from './basic-modal-context';
import { UpsellItemInfo } from './upsell-item-info';

export class CheckoutUpsellsModalContext extends BasicModalContext {
  constructor(public upsellItemInfos: UpsellItemInfo[], public shouldProceedToCheckout?: boolean) {
    super();

    this.config = { upsellItemInfos, shouldProceedToCheckout };
    this.class = 'centered no-shadow checkout-upsell-modal';

    if (upsellItemInfos.length > 2) {
      this.class = `${this.class} modal-lg`;
    } else {
      this.class = `${this.class} modal-md`;
    }
  }
}
